export default "__VITE_ASSET__BJTSEyRC__"